import type { FaireProductEntity } from "../../entity_types/product";

export const p_hvubmpmb65: FaireProductEntity = {
  token: "p_hvubmpmb65",
  type: "product",
  name: "SKATE LONG SLEEVE IN OLIVE STRIPE",
  brandToken: "b_9jdg5bykvm",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c8e3e30c20857a2e134eb65aa444819d17b0fdf8a3e664a57ed77ef98cbf1032.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c31bd490a7aaedbcb44e0d012317e9711324a9e4cad7af0845663412ee09cc7f.jpeg",
    "https://cdn.faire.com/fastly/ec52352e0ec8dcf138d9ae76d0e1bb3fe632cfe74d84318ccde98b07e346a3ea.jpeg",
    "https://cdn.faire.com/fastly/29b75c1e117932e6bd78791cac65a7935d686f8de14d0528d8631ae23acab2d7.jpeg",
    "https://cdn.faire.com/fastly/66e4b3db8d4e28fd31cdc37b19559f6de6ff3a34072a39adb093fcfb95aa121e.jpeg",
    "https://cdn.faire.com/fastly/fd0aff6dc53407923b4a00fc07a05f15d440ea8677c0b57d38021160240b93d1.jpeg",
    "https://cdn.faire.com/fastly/f7c25c6ac5f89610905a5704cfcab0088bb7ab72c72598742c14e27bfc8e1f65.jpeg",
    "https://cdn.faire.com/fastly/3c092c95039a8e0c3299c888a6e3f9ed053851b367382e8328284c35658d3de6.jpeg",
    "https://cdn.faire.com/fastly/9af89afa0c0151434cafc6ee049e45d24c78bd4c9e2a634b5e9d419bcdf36ad8.jpeg",
  ],
  priceDollars: 67.9,
  description:
    "Inspired by 90’s layering, the Skate Long Sleeve is a double-layered crew neck shirt featuring a long sleeve base with a short sleeve tee over it. The fit is slightly boxy and loose, giving it an easy, relaxed feel. Designed to look perfectly layered without the extra bulk, it’s a cozy, effortless piece you’ll keep reaching for.\n\n * 2 in 1 layered long sleeve \n * Slightly oversized, boxy fit \n * Classic crew neck\n\n * Inspired by 90s styling\n\n * Ethically made in Los Angeles ",
  tags: [],
  msrpDollars: 135.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:50.560Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
